<app-warning-message *ngIf="show === true">

    <div class="warning">

        <div class="warning__text">
            {{ message }}
        </div>

        <div>
            <div class="warning__close" (click)="handleDismissClick()">
                <app-icon
                    icon="times"
                    size="lg"
                    title="Close">
                </app-icon>
            </div>
        </div>

    </div>
    
</app-warning-message>